export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreDiscountModal/components/AddUpdateTyreDiscountForm";
